import * as Button from "./button";
export { Button };



//////////////////
// WEBPACK FOOTER
// ./app/shared/patterns/global/header/button/index.ts
// module id = GvR7
// module chunks = 2